import React from 'react';
import styled from 'styled-components';
import document from 'images/information-center/documents.svg';

const DocumentsListStyle = styled.ul`
  a {
    border-bottom: 1px solid #fff;
    display: flex;
    align-items: center;
    padding: 15px 0;
    font-size: 18px;
    color: #fff;
    transition: color .3s linear;
    &:hover {
      color: #edbd2f;
    }
  }
  span {
    margin-left: 15px;
  }
  img {
    width: 40px;
  }
`;

const DocumentsList = ({ documents }) => (
    <DocumentsListStyle>
      {documents.map((item, i) => (
        <li key={i}>
        <a href={item.get('attachment')} target="_blank">
           <img src={document} alt="document"/>
           <span>{item.get('name')}</span>
         </a>
         </li>
      ))}
    </DocumentsListStyle>


)
export default DocumentsList;



// WEBPACK FOOTER //
// ./src/system/information-center/documents/documents-list.js